export const LMT_ENHCMT_updateMonthlyStatementErrReducer = {
  LMT_ENHCMT_updateMonthlyStatementErr: (state, action) => {
    state.monthlyStatementErr = action.payload;
  },
};
